<h2 [innerHTML]="msg.title"></h2>
<p [innerHTML]="msg.desc"></p>
<div class="db-button-wrap">
  <button class="ds-btn-{{msg.btnColor}} m" (click)="handleAction()">
    <span [innerHTML]="msg.btnLabel"></span>
  </button>
</div>
